// extracted by mini-css-extract-plugin
export default {"footer":"V-z","footerContainer":"W-z"};